/* ============================================================
   HOMEPAGE CRO JS — Karar Store
   Marquee trust bar, scroll reveal, testimonials
   (features strip + COD banner REMOVED per user request 2026-08-30)
   ============================================================ */

(function () {
  'use strict';

  var isHomepage = window.location.pathname === '/' || window.location.pathname === '';
  if (!isHomepage) return;

  // ── 1. MARQUEE TRUST BAR ──
  function buildMarquee() {
    var items = [
      { icon: '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>', text: 'Full-Grain Leather' },
      { icon: '<path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>', text: 'Cash on Delivery' },
      { icon: '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>', text: '30-Day Free Returns' },
      { icon: '<path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4.18L19 8.3v3.7c0 3.83-2.87 7.4-7 8.57-4.13-1.17-7-4.74-7-8.57V8.3l7-3.12z"/>', text: '3-Year Warranty' },
      { icon: '<path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>', text: 'Trusted by Thousands' },
      { icon: '<path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/>', text: 'Fast Dispatch' },
      { icon: '<path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>', text: 'Free Shipping on Prepaid' },
      { icon: '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>', text: 'Made for Pakistan' },
    ];
    var html = items.map(function(i) {
      return '<span class="cro-marquee-item"><svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">' + i.icon + '</svg>' + i.text + '</span>';
    }).join('');
    var wrap = document.createElement('div');
    wrap.className = 'cro-marquee-wrap';
    wrap.innerHTML = '<div class="cro-marquee-track">' + html + html + '</div>';
    var header = document.querySelector('.section-header, header-section, #shopify-section-header');
    if (header) header.insertAdjacentElement('afterend', wrap);
    else document.querySelector('main') && document.querySelector('main').insertAdjacentElement('beforebegin', wrap);
  }

  // ── 2. TESTIMONIALS ──
  function buildTestimonials() {
    var reviews = [
      { stars: 5, text: 'Bought the Slimfold for Eid and it\'s been in my pocket every day since. The leather quality is unreal for the price.', author: 'Hamza R. — Lahore' },
      { stars: 5, text: 'Ordered COD, arrived in 2 days. Packaging was premium, the wallet exceeded my expectations. My father loved his gift.', author: 'Bilal A. — Karachi' },
      { stars: 5, text: 'Finally a Pakistani brand that doesn\'t compromise. The stitching is solid and the leather smells incredible.', author: 'Usman K. — Islamabad' },
    ];
    var section = document.createElement('div');
    section.className = 'cro-testimonials cro-reveal';
    section.innerHTML = '<div class="cro-testimonials__inner"><h2 class="cro-testimonials__heading">Trusted by Thousands Across Pakistan</h2><div class="cro-testimonials__grid">' +
      reviews.map(function(r) {
        return '<div class="cro-testimonial-card cro-reveal"><div class="cro-testimonial-stars">' + '★'.repeat(r.stars) + '</div><p class="cro-testimonial-text">“' + r.text + '”</p><div class="cro-testimonial-author">' + r.author + '</div></div>';
      }).join('') + '</div></div>';
    var richText = document.querySelector('#shopify-section-rich_text_rMLfqU');
    if (richText) richText.insertAdjacentElement('beforebegin', section);
    else document.querySelector('main') && document.querySelector('main').appendChild(section);
  }

  // ── 3. SCROLL REVEAL ──
  function initScrollReveal() {
    var selectors = ['.collection', '.multicolumn', '.image-with-text', '.rich-text', '.banner:not(:first-child)'];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el, i) {
        el.classList.add('cro-reveal');
        if (i === 1) el.classList.add('cro-reveal-delay-1');
        if (i === 2) el.classList.add('cro-reveal-delay-2');
      });
    });
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.cro-reveal').forEach(function(el) { observer.observe(el); });
  }

  // ── 4. CARD ENHANCEMENTS ──
  function initCardEnhancements() {
    document.querySelectorAll('.quick-add__submit').forEach(function(btn) {
      if (btn.textContent.trim().toLowerCase() === 'add to cart') btn.textContent = 'Quick Add';
    });
  }

  function init() {
    // REMOVED: buildCODBanner() and buildFeaturesStrip() per user request
    buildMarquee();
    buildTestimonials();
    initScrollReveal();
    initCardEnhancements();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
